/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type signUpCta_viewer$ref = any;
import type { FragmentReference } from 'relay-runtime';
declare export opaque type collection_viewer$ref: FragmentReference;
export type collection_viewer = {|
  +trackSearch: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +internal_id: ?number,
        +price: ?number,
        +base_price: ?number,
        +title: ?string,
        +added_to_cart: ?boolean,
        +slug: ?string,
        +duration: ?number,
        +score: ?number,
        +boosted_score: ?number,
        +stems_available: ?boolean,
        +customizable: ?boolean,
        +matched_exclusions: ?$ReadOnlyArray<?number>,
        +tempos: ?$ReadOnlyArray<?{|
          +id: string,
          +name: ?string,
          +value: ?number,
        |}>,
        +assets: ?$ReadOnlyArray<?{|
          +id: string,
          +version: ?string,
          +type: ?string,
          +file_format: ?string,
          +path: ?string,
          +metadata: ?any,
        |}>,
        +artist: ?{|
          +id: string,
          +name: ?string,
          +slug: ?string,
          +bio: ?string,
          +bandcamp: ?string,
          +facebook: ?string,
          +instagram: ?string,
          +itunes: ?string,
          +soundcloud: ?string,
          +spotify: ?string,
          +twitter: ?string,
          +wiki: ?string,
          +youtube: ?string,
          +homebase: ?string,
          +assets: ?$ReadOnlyArray<?{|
            +id: string,
            +version: ?string,
            +type: ?string,
            +file_format: ?string,
            +path: ?string,
            +metadata: ?any,
          |}>,
        |},
        +terms: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +is_highlighted: ?boolean,
              +name: ?string,
              +parent_id: ?string,
              +taxonomy: ?{|
                +id: string,
                +internal_id: ?number,
                +name: ?string,
              |},
            |},
          |}>,
        |},
        +collections: ?{|
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +id: string,
              +description: ?string,
              +name: string,
              +slug: ?string,
              +category: ?{|
                +id: string,
                +name: ?string,
              |},
              +assets: ?$ReadOnlyArray<?{|
                +id: string,
                +version: ?string,
                +type: ?string,
                +file_format: ?string,
                +path: ?string,
                +metadata: ?any,
              |}>,
            |},
          |}>,
        |},
        +association_id: ?string,
        +selected_version: ?string,
      |},
    |}>,
    +total: ?number,
  |},
  +$fragmentRefs: signUpCta_viewer$ref,
  +$refType: collection_viewer$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "slug",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "internal_id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "assets",
  "storageKey": null,
  "args": null,
  "concreteType": "Asset",
  "plural": true,
  "selections": [
    v0,
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "version",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "type",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "file_format",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "metadata",
      "args": null,
      "storageKey": null
    }
  ]
};
return {
  "kind": "Fragment",
  "name": "collection_viewer",
  "type": "Viewer",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "trackSearch"
        ]
      }
    ]
  },
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "query",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "filters",
      "type": "TrackSearchFilters"
    },
    {
      "kind": "RootArgument",
      "name": "license_params",
      "type": "[LicenseUsageParamsInput]"
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "signUpCta_viewer",
      "args": null
    },
    {
      "kind": "LinkedField",
      "alias": "trackSearch",
      "name": "__collection_trackSearch_connection",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "filters",
          "variableName": "filters",
          "type": "TrackSearchFilters"
        },
        {
          "kind": "Variable",
          "name": "license_params",
          "variableName": "license_params",
          "type": "[LicenseUsageParamsInput]"
        },
        {
          "kind": "Literal",
          "name": "offset",
          "value": 0,
          "type": "Int"
        },
        {
          "kind": "Variable",
          "name": "query",
          "variableName": "query",
          "type": "String"
        }
      ],
      "concreteType": "TrackSearchResultConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "TrackSearchResultEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "TrackSearchResult",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "stems_available",
                  "args": null,
                  "storageKey": null
                },
                v0,
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "price",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "base_price",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "title",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "added_to_cart",
                  "args": null,
                  "storageKey": null
                },
                v1,
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "duration",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "score",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "boosted_score",
                  "args": null,
                  "storageKey": null
                },
                v2,
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "customizable",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "matched_exclusions",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "tempos",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Tempo",
                  "plural": true,
                  "selections": [
                    v0,
                    v3,
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "value",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                },
                v4,
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "artist",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "Artist",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "itunes",
                      "args": null,
                      "storageKey": null
                    },
                    v0,
                    v1,
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "bio",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "bandcamp",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "facebook",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "instagram",
                      "args": null,
                      "storageKey": null
                    },
                    v3,
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "soundcloud",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "spotify",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "twitter",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "wiki",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "youtube",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "homebase",
                      "args": null,
                      "storageKey": null
                    },
                    v4
                  ]
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "terms",
                  "storageKey": "terms(first:100)",
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "first",
                      "value": 100,
                      "type": "Int"
                    }
                  ],
                  "concreteType": "TaxonomyTermConnection",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "TaxonomyTermEdge",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "node",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "TaxonomyTerm",
                          "plural": false,
                          "selections": [
                            v0,
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "is_highlighted",
                              "args": null,
                              "storageKey": null
                            },
                            v3,
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "parent_id",
                              "args": null,
                              "storageKey": null
                            },
                            {
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "taxonomy",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "Taxonomy",
                              "plural": false,
                              "selections": [
                                v0,
                                v2,
                                v3
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "collections",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "CollectionTrackConnection",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "CollectionTrackEdge",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "node",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "Collection",
                          "plural": false,
                          "selections": [
                            v0,
                            {
                              "kind": "ScalarField",
                              "alias": null,
                              "name": "description",
                              "args": null,
                              "storageKey": null
                            },
                            v3,
                            v1,
                            {
                              "kind": "LinkedField",
                              "alias": null,
                              "name": "category",
                              "storageKey": null,
                              "args": null,
                              "concreteType": "CollectionCategory",
                              "plural": false,
                              "selections": [
                                v0,
                                v3
                              ]
                            },
                            v4
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "association_id",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "selected_version",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "__typename",
                  "args": null,
                  "storageKey": null
                }
              ]
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "cursor",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "total",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "pageInfo",
          "storageKey": null,
          "args": null,
          "concreteType": "PageInfo",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "endCursor",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "hasNextPage",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
})();
(node/*: any*/).hash = '0fef4d0fc71fef37de4b93a9abf5c3fe';
module.exports = node;



// WEBPACK FOOTER //
// ./src/public/relay/__generated__/collection_viewer.graphql.js